module.exports = __webpack_public_path__ + "named-729ba7ae06db85896b0021492e970d02-apple-touch-icon-57x57.png";